import {Local} from './Local';

export const ar: Local = {
  translation: {
    language: {
      label: 'اللغة',
      en: 'English',
      ar: 'العربية',
    },
    theme: 'الوضع',
    validation: {
      requiredField: 'الحقل مطلوب',
      mustBePositive: 'يجب ان يكون موجب',
    },
    general: {
      enable: 'تفعيل',
      enableAll: 'تفعيل الكل',
      homePage: 'تعيين كصفحة رئيسية',
      home: 'الرئيسية',
    },
    publish: 'النشر',
    notifications: 'الإشعارات',
    tags: 'كلمات دليلية',
    clearFilters: 'إعادة تعيين',
    filter: 'فلتر',
    sort: 'ترتيب',
    login: 'تسجيل دخول',
    logout: 'تسجيل خروج',
    confirmDeletion: 'تأكيد الحذف',
    generalErrorMsg: 'عذرا، هناك خطأ ما',
    successDelMsg: 'تم حذف الشعار البديل بنجاح',
    successMsg: 'تم, بنجاح',
    warning: 'تحذير',
    actions: 'الأحداث',
    action: {
      new: 'جديد',
      edit: 'تعديل',
      delete: 'حذف',
      add: 'إضافة',
      save: 'حفظ',
      undo: 'تراجع',
      redo: 'إعادة',
      apply: 'نشر',
      cancel: 'الغاء',
      preview: 'معاينة',
      set: 'وضع',
      open: 'فتح',
      accept: 'موافق',
      close: 'إغلاق',
      refresh: 'تحديث',
    },
    dashboard: 'لوحة القيادة',
    dashboardHeader: 'الجزء العلوي',
    dashboardFooter: 'الجزء السفلي',
    designer: 'المصمم',
    'api-resource': 'لوحة تحكم واجهة برمجة التطبيقات',
    'global-variables': 'المتغيرات العامة',
    configurations: 'الإعدادات',
    services: 'الخدمات',
    configurationsOf: 'إعدادات',
    properties: 'الخصائص',
    layers: 'الطبقات',
    deleteMsgConfirmation: 'هل أنت متأكد أنك تريد الحذف؟',
    builder: {
      changeTheme: 'تغيير المظهر',
      group: 'مجموعة',
      createScope: 'اضافة مجال',
      createPageState: 'اضافة متغير على الصفحة',
      stateCreated: 'تم انشاء القيمة بنجاح',
      noPageInEditMode: 'لا يوجد صفحة في حالة التعديل',
      arrayPlaceholder: 'أدخل مصفوفة (مثال: [1, 2, 3])',
      jsonPlaceholder: 'أدخل كائن JSON (مثال: {"key": "value"})',
      booleanPlaceholder: 'أدخل قيمة منطقية (مثال: true أو false)',
      when: 'عندما',
      do: 'نفذ',
      on: 'في',
      if: 'اذا',
      then: 'ثم',
      else: 'وإلا',
      finally: 'في النهاية',
      event: 'حدث',
      condition: 'شرط',
      success: 'نجاح',
      failed: 'فشل',
      finish: 'إنهاء',
      addEvent: 'إضافة حدث',
      addActionGroup: 'إضافة مجموعة أحداث',
      editActionGroup: 'تعديل مجموعة أحداث',
      editEvent: 'تعديل حدث',
      addCondition: 'إضافة شرط',
      action: {
        action: 'حدث',
        actions: 'الأحداث',
        addAction: 'إضافة حدث',
        editAction: 'تعديل حدث',
        addActionGroup: 'إضافة مجموعة أحداث',
        actionGroupNameUnique: 'اسم مجموعة الأحداث يجب أن يكون فريداً',
        deleteActionGroupMsg: 'سيؤدي حذف مجموعة الأحداث هذه إلى إزالتها من جميع الاستخدامات. هل ترغب في المتابعة؟',
        deleteEventMsg: 'سيؤدي حذف هذا الحدث إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
        deleteConditionMsg: 'سيؤدي حذف الشرط هذه إلى إزالتها نهائيا. هل ترغب في المتابعة؟',
        deleteActionMsg: 'سيؤدي حذف هذا الحدث إلى إزالته نهائيا. هل ترغب في المتابعة؟',
        actionConfig: 'خصائص الحدث',
        actionDefinition: 'تعريف الحدث',
        actionDefinitionInfo: {
          title: 'تعريف الإجراء',
          label: 'في هذا القسم يمكنك تحديد الإجراء الذي سيتم تنفيذه عند حدوث الحدث. يمكنك اختيار إجراء من القائمة .',
        },
        actionsElement: {
          title: 'تكوين الأحداث',
          label: 'قم بتكوين الأحداث للعنصر المحدد. يمكنك إضافة أحداث جديدة، تعديل الأحداث الحالية، أو حذفها.',
        },
        actionConfigInfo: {
          title: 'إعدادات الإجراء',
          label:
            'هنا تقوم بضبط تفاصيل الإجراء. حسب نوع الإجراء، قد تحتاج إلى إضافة خيارات أو معلمات أو إعدادات إضافية.',
        },
      },
      state: {
        states: 'القيم',
        addState: 'إضافة قيمة',
        editState: 'تعديل قيمة',
        createScope: 'إنشاء نطاق',
        editScope: 'تعديل نطاق',
        pageStateInfo: {
          title: 'قيم الصفحة',
          label: `تمكّنك قيم الصفحة من تعريف وإدارة البيانات أو الشروط الديناميكية التي تتحكم في سلوك الصفحة. 
كما يمكن استخدامها لتعريف بيانات وعرضها من خلال مكوّنات Meta.

على سبيل المثال، يمكنك إنشاء قيم مثل التحميل، أو الخطأ، أو النجاح. 
ويمكنك إدارة هذه القيم عن طريق إنشائها أو تعديلها أو حذفها عند الحاجة.`,
        },
        addStateInfo: {
          title: 'إضافة حالة',
          label:
            'استخدم هذا النموذج لإنشاء حالة جديدة للصفحة. يجب أن تحتوي كل حالة على اسم ونوع وقيمة فريدة ضمن نفس النطاق.',
        },
        scopeInfo: {
          title: 'النطاق',
          label:
            'تُستخدم النطاقات لربط الحالات معًا. فهي تساعد في تنظيم وإدارة الحالات بشكل فعّال. يمكنك إنشاء أو تعديل أو حذف النطاقات حسب الحاجة.',
        },
        createScopeInfo: {
          title: 'إنشاء النطاق',
          label:
            'تُستخدم النطاقات لجمع الحالات ذات الصلة معًا لتنظيم أفضل. يجب أن يكون اسم النطاق فريدًا، ويُفضل أن يكون وصفيًا ليسهّل إدارة بياناتك بشكل أكثر فعالية.',
        },
      },
      resource: {
        title: 'المورد',
        info: {
          label: `تُستخدم موارد الصفحة لإدارة طلبات واجهة برمجة التطبيقات (API) والمجموعات على مستوى الصفحة. 
  يمكنك إنشاء أو تعديل أو حذف طلبات الـ API والمجموعات حسب الحاجة.

  ملاحظة: يجب تعريف جميع طلبات الـ API والمجموعات أولاً في لوحة تحكم الـ API قبل أن تتمكن من استخدامها في الصفحة.`,
        },
        addCollectionInfo: {
          label: `يتيح لك هذا النموذج اختيار مجموعة قمت بإنشائها مسبقًا في لوحة تحكم الـ API.  
بمجرد إضافتها، سيتم ربط المجموعة بالصفحة الحالية، مما يمنحك وصولًا مباشرًا إلى الموارد المرتبطة بها ويسهّل إدارتها داخل الصفحة.`,
        },
        addRequestInfo: {
          label: `يتيح لك هذا النموذج اختيار طلب API قمت بإنشائه مسبقًا في لوحة تحكم الـ API.  
بعد إضافته، سيتم ربط هذا الطلب بالصفحة الحالية مما يتيح لك الوصول بسهولة إلى بيانات الاستجابة واستخدامها داخل الصفحة.`,
        },
      },
      deleteScopeMsg: 'سيؤدي حذف هذا النطاق إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      deleteStateMsg: 'سيؤدي حذف هذا إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      deleteCollectionMsg: 'سيؤدي حذف هذه المجموعة إلى إزالتها من جميع الاستخدامات. هل ترغب في المتابعة؟',
      deleteApiRequestMsg: 'سيؤدي حذف هذا الطلب إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      noEvents: 'هذا العنصر لا يحتوي على أي أحداث',
      status: 'الحالة',
      selectCollection: 'حدد مجموعة',
      selectRequest: 'حدد طلب',
      loadingThinking: 'جارٍ التفكير...',
      loadingGeneratingResponse: 'جارٍ توليد الرد...',
      loadingFetchingData: 'جارٍ جلب البيانات...',
      loadingComposingAnswer: 'جارٍ صياغة أفضل إجابة...',
      loadingCheckingSources: 'جارٍ التحقق من المصادر...',
      loadingFinalTouches: 'جارٍ إضافة اللمسات الأخيرة...',
      loadingAlmostDone: 'قاربنا على الانتهاء...',
      aiBuilder: 'البنّاء الذكي',
      viewPortInfo: {
        desktop: {
          label: 'سطح المكتب',
          description: 'هذا هو العرض الافتراضي. الأنماط التي تُطبق هنا ستظهر في جميع الأجهزة ما لم يتم تعديلها.',
        },
        tablet: {
          label: 'الجهاز اللوحي',
          description: 'الأنماط التي تُطبق هنا ستتجاوز إعدادات سطح المكتب وتظهر فقط على الأجهزة اللوحية.',
        },
        mobile: {
          label: 'الهاتف',
          description: 'أصغر عرض للصفحة. الأنماط هنا ستتجاوز إعدادات سطح المكتب والجهاز اللوحي لتناسب الهواتف.',
        },
      },
      addElement: {
        title: 'إضافة عنصر',
        label:
          'قم بإضافة عناصر إلى صفحتك من خلال اختيار العناصر المتاحة من الشريط الجانبي. يمكنك سحب وإفلات العناصر في الصفحة وتخصيصها حسب احتياجاتك.',
      },
      designElement: {
        title: 'تخصيص العنصر',
        label: 'قم بتخصيص خصائص العنصر المحدد. يمكنك تعديل الأنماط، الأبعاد، المحاذاة، والمزيد.',
      },
      actionsElement: {
        title: 'تكوين الأحداث',
        label: 'قم بتكوين الأحداث للعنصر المحدد. يمكنك إضافة أحداث جديدة، تعديل الأحداث الحالية، أو حذفها.',
      },
      AiElement: {
        label:
          'استخدم مساعد الذكاء الاصطناعي لإنشاء صفحات جديدة. أدخل طلبًا وسيقوم المساعد بإنشاء صفحة بناءً على طلبك.',
      },
      eventInfo: {
        title: 'الحدث',
        label:
          'الأحداث تحدد متى يتم تنفيذ الإجراءات. اختر حدثًا (مثل النقر أو التحميل) لتهيئة الإجراءات التي يقوم بتشغيلها.',
      },
      eventGroupInfo_ar: {
        title: 'مجموعة الأحداث',
        label:
          'تسمح لك مجموعات الأحداث بتنظيم عدة أحداث معًا. يمكنك إضافة أو تعديل أو حذف المجموعات، وتعيين شروط قبل تشغيل الحدث، وربط مجموعات متعددة للحصول على تدفقات أكثر تعقيدًا.',
      },
      actionGroupInfo: {
        title: 'مجموعة الأحداث',
        label:
          'تساعدك مجموعات الأحداث على تنظيم عدة أحداث معًا. يمكنك إنشاء أو تعديل أو حذف المجموعات، إضافة شروط قبل تشغيل الحدث، وربط مجموعات متعددة للحصول على سلوك أكثر تقدمًا.',
      },
    },
    settings: {
      settings: 'الإعدادات',
      pageSettings: 'إعدادات الصفحة',
      pageSettingsInfo: {
        label:
          'في إعدادات الصفحة يمكنك إدارة جميع الإعدادات العامة الخاصة بالصفحة، مثل اسم الصفحة والأيقونة والإعدادات الأخرى.',
      },
      pageTitle: 'عنوان الصفحة',
      pageIcon: 'رمز الصفحة',
      addWidget: 'إضافة قطعة',
      insertRow: 'أدخل صفًا جديدًا',
      clickToEdit: 'انقر فوق أحد المكونات لبدء التحرير',
      spacing: 'المساحات',
      measures: 'الأبعاد',
      alignment: 'تنسيق',
      noSectionsMsgTitle: 'قم بإنشاء قسم أولاً',
      noSectionsMsg:
        'لبدء التحرير، يجب عليك أولاً إنشاء قسم. قم بالمرور فوق المحرر وسترى زر (+)، اضغط على الزر وستكون جاهزًا للانطلاق أو من الزر أدناه',
      layout: {
        label: 'التنسيق',
        width: 'العرض',
        minWidth: 'الحد الأدنى للعرض',
        maxWidth: 'أقصى عرض',
        height: 'الطول',
        minHeight: 'الحد الأدنى للارتفاع',
        maxHeight: 'أقصى طول',
        margin: 'الهامش',
        padding: 'التبطين',
        resizeMode: 'وضع تغيير الحجم',
        contain: 'يحتوي',
        cover: 'يغطي',
        stretch: 'تمتد',
        repeat: 'تكرر',
        center: 'فى الوسط',
        left: 'اليسار',
        right: 'اليمين',
        top: 'الاعلى',
        bottom: 'الأسفل',
        gap: 'الفجوة',
      },
      style: {
        label: 'الشكل',
        opacity: 'الشفافية',
        color: 'اللون',
        background: 'الخلفية',
        backgroundColor: 'لون الخلفية',
      },
      typography: {
        label: 'النصوص',
        initialText: 'يظهر المحتوى الخاص بك هنا، قم بتحرير أنماط النص والمحتوى أو قم بإزالة هذا النص من الشريط الجانبي',
        fontSize: 'الحجم',
        fontWeight: 'السمك',
        textAlign: 'محاذاة',
        start: 'البداية',
        left: 'اليسار',
        right: 'اليمين',
        center: 'الوسط',
        thin: 'رفيع',
        normal: 'طبيعي',
        bold: 'سميك',
        lineHeight: 'ارتفاع الخط',
      },
      basic: {
        label: 'أساسي',
        text: 'محتوى النص',
        url: 'الرابط',
      },
      button: {
        empty: 'فارغ',
        filled: 'مملوء',
        outlined: 'محدد',
        danger: 'خطر',
        info: 'معلومات',
        neutral: 'محايد',
        primary: 'أساسي',
        success: 'نجاح',
        warning: 'تحذير',
        hierarchy: 'النوع',
      },
      accordion: {
        newSection: 'قسم جديد',
      },
      borders: {
        label: 'الحدود',
        borderWidth: 'عرض الحدود',
        borderRadius: 'نصف قطر الحدود',
        borderColor: 'لون الحدود',
        width: 'العرض',
        color: 'اللون',
        radius: 'نصف القطر',
      },
      flex: {
        label: 'المرونة',
        direction: 'الاتجاه',
        wrap: 'اللف',
        align: 'المحاذاة',
        alignSelf: 'محاذاة الذات',
        justify: 'ملأ السطر',
        row: 'صف',
        column: 'عمود',
        nowrap: 'ممنوع اللف',
        wrapReverse: 'لف بالعكس',
        flexStart: 'البداية',
        flexEnd: 'النهاية',
        center: 'الوسط',
        stretch: 'ممتد',
        spaceEvenly: 'تباعد بالتساوي',
        spaceBetween: 'الفضاء بين',
        spaceAround: 'الفضاء حول',
        grow: 'النمو',
      },
    },
    viewportSizes: {
      mobile: 'هاتف محمول',
      tablet: 'جهاز لوحى',
      desktop: 'جهاز مكتبى',
    },
    status: {
      SUCCEEDED: 'نجح',
      FAILED: 'فشل',
      RUNNING: 'جارٍ',
      COMPLETED: 'مكتمل',
      SKIPPED: 'تم التخطي',
      NOT_STARTED: 'لم يبدأ',
    },
    buildProfile: {
      PREVIEW: 'معاينة',
      PRODUCTION: 'إنتاج',
    },
    appConfig: {
      userInterface: 'واجهة المستخدم',
      title: 'التطبيق',
      logo: 'الشعار',
      alternativeLogo: 'الشعار البديل',
      miniLogo: 'الشعار الصغير',
      icon: 'الأيقونة',
      icons: 'الأيقونات',
      mobileIcons: 'أيقونات الهاتف ',
      appIcon: 'أيقونة التطبيق',
      splashScreen: 'شاشة البداية',
      brandColors: 'لون العلامة التجارية',
      generalSettings: 'الإعدادات الأساسية',
      designSystem: {
        title: 'نظام التصميم',
        label:
          'يتيح لك نظام التصميم تخصيص الجوانب المرئية لتطبيقك. تساعد هذه الإعدادات في الحفاظ على هوية علامة تجارية متسقة عبر تطبيقك.',
      },
      brandColorInfo: {
        title: 'لون العلامة التجارية',
        label: 'اللون الرئيسي الذي سيتم تطبيقه على تطبيق الهاتف المحمول والويب في وضعي الضوء والظلام.',
      },
      appName: 'إسم التطبيق',
      appNameInfo: {
        title: 'إسم التطبيق',
        label: 'اسم التطبيق الذي سيتم عرضه في تطبيق الويب.',
      },
      appIconInfo: {
        title: 'أيقونة التطبيق',
        label: 'ستظهر هذه الأيقونة في متاجر التطبيقات وعلى جهاز المستخدم بعد تثبيت التطبيق.',
      },
      splashScreenInfo: {
        title: 'شاشة البداية',
        label: 'سيتم عرض هذه الصورة أثناء تحميل التطبيق. توفّر تجربة تتماشى مع هوية التطبيق قبل أن يصبح جاهزًا تمامًا.',
      },
      appLogoInfo: {
        title: 'شعار التطبيق',
        label: 'الشعار الرئيسي للتطبيق. سيظهر في شريط التنقل ويُعبّر عن هوية العلامة التجارية للتطبيق.',
      },
      alternativeLogoInfo: {
        title: 'الشعار البديل',
        label: 'سيُستخدم هذا الشعار في الوضع الداكن. إذا لم يتم توفيره، فسيتم عرض الشعار الرئيسي بدلاً منه.',
      },
      miniLogoInfo: {
        title: 'الشعار المصغّر',
        label:
          'سيتم عرض هذا الشعار عند طي الشريط الجانبي. يكون عادة نسخة مصغّرة من الشعار الرئيسي، ويُستخدم أيضًا كرمز favicon.',
      },
      settings: 'الإعدادات',
      enableSettings: 'عرض الإعدادات',
      enableSettingsInfo: {
        title: 'عرض الإعدادات',
        label: 'قم بتبديل هذا الخيار لإظهار أو إخفاء صفحة الإعدادات في تطبيقك.',
      },
    },
    mobileReleaseHub: {
      title: 'مركز إصدارات الهاتف',
      mobileIcons: 'أيقونات الهاتف',
      buildApp: 'بناء التطبيق',
      updateApp: 'تحديث التطبيق',
      publish: 'نشر',
      publishApp: 'نشر التطبيق',
      publishAppInfo: 'نشر في متجر التطبيقات',
      runHistory: 'سجل التشغيل',
      downloadApp: 'تحميل التطبيق',
      android: 'أندرويد',
      ios: 'IOS',
      all: 'الكل',
      none: 'لا يوجد',
      buildError: 'خطأ النشر',
      actions: 'الأحداث',
      deleteBuild: {
        title: 'حذف البناء',
        message: 'هل أنت متأكد من حذف هذا البناء؟ لا يمكن التراجع عن هذا الإجراء.',
        error: 'حدث خطأ أثناء حذف البناء',
        success: 'تم حذف البناء بنجاح',
      },
      failedToFetchConfig: 'فشل في الحصول على إعدادات التكوين',
      loadingConfig: 'جاري تحميل إعدادات التكوين',
      error: 'الخطأ',
      configuration: 'الإعدادات',
      appName: 'إسم التطبيق',
      appVersion: 'إصدار التطبيق',
      easOwner: 'مالك ال EAS',
      easProjectId: 'معرف مشروع EAS',
      steps: 'الخطوات',
      status: 'الحالة',
      buildStatus: 'حالة البناء',
      publishStatus: 'حالة النشر',
      buildHistory: 'سجل البناء',
      testConnection: 'اختبار الاتصال',
      easConfig: 'إعدادات EAS',
      platform: 'المنصة',
      channel: 'القناة',
      selectPlatform: 'حددالمنصة',
      newBuildsOccurMessage: 'يعتمد الحد الأقصى لعدد البناء على خطة حساب EAS الخاصة بك.',
      somethingWentWrong: 'حدث خطأ ما',
      easConnectedSuccessfully: 'تم الاتصال بـ EAS بنجاح',
      doneSuccessfully: 'تم بنجاح',
      usernameOrPasswordIncorrect: 'اسم المستخدم أو كلمة المرور غير صحيحة',
      easToken: 'الرمز السري ل EAS',
      previewApp: 'معاينة التطبيق',
      ascAppId: 'معرف التطبيق',
      androidTrack: 'مسار الأندرويد',
      selectAndroidTrack: 'إختر مسار الأندرويد',
      profile: 'الملف',
      selectProfile: 'اختر الملف',
      preview: 'معاينة',
      production: 'إنتاج',
      syncSourceCode: 'مزامنة الكود المصدري',
      authPackageRegistry: 'المصادقة على سجل الحزم',
      configureApplets: 'إعداد الوحدات',
      configureApp: 'إعداد التطبيق',
      installPackages: 'تثبيت الحزم',
      buildAndroid: 'بناء أندرويد',
      buildIos: 'بناء iOS',
      publishToPlayStore: 'النشر على متجر بلاي',
      publishToAppStore: 'النشر على متجر آب',
      repositoryUpdated: 'تم تحديث المستودع',
      registryLoggedIn: 'تم تسجيل الدخول إلى السجل',
      appletsUpdated: 'تم تحديث المنتجات المستعملة',
      appConfigMapped: 'تم ربط إعداد التطبيق',
      packagesInstalled: 'تم تثبيت الحزم',
      deployAndroidSent: 'تم إرسال نشر أندرويد',
      deployIosSent: 'تم إرسال نشر iOS',
      updateCompleted: 'اكتمل التحديث',
      otaHistory: 'سجل التحديثات المباشرة',
      otaUpdate: 'التحديثات المباشرة',
      otaUpdateAction: 'إرسال تحديث',
      otaUpdateInfo: {
        title: 'التحديثات المباشرة',
        label:
          'تحديثات Over-The-Air (OTA) تسمح لتطبيقك بتلقي ميزات جديدة أو إصلاحات دون الحاجة إلى تحميل إصدار جديد من المتجر.',
      },
      buildDeploy: {
        title: 'إصدارات التطبيق',
        label: 'أنشئ إصدارات معاينة أو إنتاجية لنظامي Android وiOS، وتابع حالة البناء، ثم انشر الإصدارات في متاجر التطبيقات.',
      },
    },
    aiAssistant: {
      enable: 'مفعّل',
      disable: 'معطّل',
      apiKeyLabel: 'مفتاح API',
      apiKeyDescription: 'أدخل مفتاح API لخدمة الذكاء الاصطناعي لتمكين ميزات الذكاء الاصطناعي في تطبيقك.',
      apiKeyDescriptionExist: 'تم تعيين مفتاح API بالفعل. أدخل مفتاحًا جديدًا لاستبداله.',
      title: 'مساعد الذكاء الاصطناعي',
      promptTitle: 'صف ما تريد إنشاؤه',
      promptHint:
        'نصيحة: اكتب تعليمات واضحة ومحددة. اذكر التخطيط، العناصر، أو النمط الذي تريده. كلما زادت التفاصيل، كان بإمكان الذكاء الاصطناعي مطابقة رؤيتك بشكل أفضل.',
      placeholder: 'مثال: أنشئ صفحة تسجيل دخول تحتوي على البريد الإلكتروني، كلمة المرور، وزر تسجيل الدخول',
      info: {
        title: 'مساعد الذكاء الاصطناعي',
        label:
          'يساعدك مساعد الذكاء الاصطناعي في إنشاء الصفحات. فهو يستخدم نماذج ذكاء اصطناعي متقدمة لفهم طلباتك والرد عليها.',
      },
      apiKeyInfo: {
        title: 'مفتاح API',
        label: 'مفتاح ال API مطلوب لمصادقة طلباتك على خدمة الذكاء الاصطناعي. ندعم حاليًا خدمة OpenAI.',
      },
    },
    appletConfig: {
      enable: 'تفعيل/عدم تفعيل',
      componentsCustomizations: 'تخصيصات المكونات',
      pleaseEnableConnector: 'للاطلاع على الخدمات المتاحة، يُرجى تفعيل هذا الموصل',
      general: 'عام',
    },
    homeConfig: {
      title: 'تخصيصات المكونات',
      enable: 'تفعيل/عدم تفعيل',
    },
    servicesAuthorization: {
      title: 'تحكم الخدمات',
    },
    generalConfig: {
      title: 'عام',
    },
    apiSettings: {
      request: 'الإستدعاء',
      noCollectionSelected: 'لم يتم اختيار أي طلب API لهذه المجموعة',
      noCollectionSelectedDes: 'يرجى إنشاء طلب API أولاً',
      apiUrl: 'الرابط',
      method: 'الطريقة',
      headers: 'الرؤوس',
      queryParams: 'معلمات الاستعلام',
      addHeader: 'إضافة رأس',
      key: 'المفتاح',
      value: 'القيمة',
      body: 'الجسم',
      preview: 'معاينة',
      mapResponse: 'ربط الإستجابة',
      testAndMapApi: 'اختبار وربط نتيجة ال API',
      sendApi: 'إرسال',
      apiResponse: 'رد الطلب',
      recommended: 'موصى به',
      addJsonPath: 'إضافة مسار JSON',
      predefinedPath: 'مسار محدد مسبقاً',
      jsonPath: 'مسار JSON',
      name: 'الاسم',
      type: 'النوع',
      enterCollectionTitle: 'أدخل عنوان المجموعة...',
      apiDetails: 'تفاصيل API',
      collection: 'مجموعة',
      addCollection: 'إضافة مجموعة',
      defaultValue: 'القيمة الافتراضية',
      collections: 'المجموعات',
      setValue: 'API تعيين القيمة من',
      editAPIName: 'تعديل المجموعة',
      addQueryParam: 'إضافة معلمة استعلام',
      apiUpdated: 'تم تحديث طلب API',
      apiDeleted: 'تم حذف طلب API',
      deleteApiRequestMsg: 'سيؤدي حذف هذا API إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      deleteCollectionMsg: 'سيؤدي حذف هذه المجموعة إلى إزالتها من جميع الاستخدامات. هل ترغب في المتابعة؟',
      fetchCollectionMsgErr: 'حدث خطأ أثناء جلب المجموعة من واجهة برمجة التطبيقات.',
      collectionDeleted: 'تم حذف المجموعة بنجاح',
    },
    globalVariables: {
      name: 'المتغيرات العامة',
      scopes: 'النطاقات',
      scope: 'مجال',
      createScope: 'إضافة مجال',
      variable: 'متغير',
      createVariable: 'إضافة متغير',
      editVariable: 'تعديل المتغير',
      secret: 'سري',
      deleteVariableMsg: 'سيؤدي حذف هذا المتغير إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      variableName: 'اسم المتغير',
      variableValue: 'قيمة المتغير',
      variableType: 'نوع المتغير',
      scopeName: 'اسم النطاق',
      editScope: 'تعديل النطاق',
      deleteScopeMsg: 'سيؤدي حذف هذا النطاق إلى إزالته من جميع الاستخدامات. هل ترغب في المتابعة؟',
      editVariableSuccess: 'تم تعديل المتغير بنجاح',
      deleteVariableSuccess: 'تم إزالة المتغير بنجاح',
      createVariableSuccess: 'تم إنشاء المتغير بنجاح',
      editScopeSuccess: 'تم تعديل النطاق بنجاح',
      createScopeSuccess: 'تم إنشاء النطاق بنجاح',
      deleteScopeSuccess: 'تم إزالة النطاق بنجاح',
      nameRequired: 'الاسم مطلوب',
      valueRequired: 'القيمة مطلوبة',
    },
    name: 'الاسم',
    value: 'القيمة',
    public: 'عام',
    private: 'خاص',
    elements: 'عناصر',
    widgets: 'القطع',
    content: 'المحتوى',
    header: 'عنوان',
    design: 'التصميم',
    variant: 'الشكل',
    type: 'النوع',
    pages: 'الصفحات',
    section: 'القسم',
    container: 'حاوية',
    changeIcon: 'تغيير الأيقونة',
    selectRequiredRoles: 'حدد الأدوار المطلوبة',
    servicePage: 'صفحة خدمة',
    contentPage: 'صفحة محتوى',
    selectService: 'اختر خدمة',
    auxiliaryPages: 'صفحات مساعدة',
    auxiliaryPage: 'صفحة مساعدة',
    auxiliaryPagesInfo:
      'الصفحات المساعدة هي صفحات إضافية يُمكن استخدامها لتوفير وظائف أو معلومات إضافية داخل تطبيقك. تُضاف هذه الصفحات إلى صفحة الإعدادات.',
    pagesGroup: 'مجموعة صفحات',
    upload: 'رفع',
    placeholder: 'نص توضيحي',
    sessions: {
      title: 'الجلسة',
      enable: 'مفعل',
      disable: 'غير مفعل',
      sessionTimeout: 'الحد الزمني للجلسة',
      info: {
        title: 'الحد الزمني للجلسة',
        label:
          'الحد الزمني للجلسة هو المدة الزمنية التي ستظل فيها الجلسة نشطة قبل أن تنتهي. بعد انتهاء الجلسة، سيحتاج المستخدم إلى تسجيل الدخول مرة أخرى.',
      },
    },
    customerSurvey: {
      title: 'استبيان العملاء',
      enable: 'مفعل',
      disable: 'غير مفعل',
      info: {
        title: 'استبيان العملاء',
        label: 'يتيح لك جمع ملاحظات المستخدمين عبر Formbricks لتحسين التطبيق وتجربة المستخدم.',
      },
      environmentId: 'معرّف البيئة',
      appUrl: 'رابط التطبيق',
      autoTriggerKey: 'مفتاح التشغيل التلقائي',
      autoTriggerKeyInfo: 'مفتاح التشغيل التلقائي مطلوب لتشغيل استطلاع رأي العملاء تلقائيًا.',
    },
    home: 'الرئيسية',
    highlighted: 'مميزة',
    pushNotification: {
      title: 'دفع الإشعارات',
      hint: 'قم بتحميل ملفات إعداد Firebase المطلوبة (لنظامي Android وiOS) لتمكين الإشعارات في تطبيقك. إذا لم تتم إضافتها، فسيتم استخدام ملفات الإعداد الافتراضية.',
      android: {
        title: 'إعدادات الأندرويد',
        placeholder: 'قم بإسقاط ملف google-services.json هنا أو انقر للتصفح',
        hint: 'قم بتحميل ملف google-services.json من لوحة تحكم Firebase لتفعيل الإشعارات لنظام أندرويد',
      },
      ios: {
        title: 'إعدادات iOS',
        placeholder: 'قم بإسقاط ملف GoogleService-Info.plist هنا أو انقر للتصفح',
        hint: 'قم بتحميل ملف GoogleService-Info.plist من لوحة تحكم Firebase لتفعيل الإشعارات لنظام iOS',
      },
    },
  },
};
